import { useUserContext } from '@/auth/UserContext';
import { Skeleton } from '@/components/Skeleton';
import { isEligibleForAds } from '@/utils/person';
import React from 'react';
import { useAdBanner } from './hooks/useAdBanner';

interface AdBannerProps {
  className?: string;
}

const AdBanner: React.FC<AdBannerProps> = ({ className }) => {
  const { user } = useUserContext();
  const isAdvertisingEnabled =
    user?.userSettings?.isAdvertisingEnabled ?? false;
  const canShowAd = isAdvertisingEnabled && isEligibleForAds(user);

  const { iframeRef, src, isEmpty, isLoaded } = useAdBanner({
    ptype: user?.personTypeId,
    grade: user?.class?.level,
    region: user?.school?.regionId,
    enabled: canShowAd,
  });

  if (!canShowAd || isEmpty || !src) {
    return null;
  }

  return (
    <div
      className={`mx-auto w-[calc(100%_-_32px)] max-w-[640px] md:w-[calc(100%_-_48px)] md:max-w-[1600px] pt-3 md:pt-6 ${className ?? ''}`}
    >
      <div className="relative">
        <iframe
          ref={iframeRef}
          src={src}
          title="Advertisement"
          className="aspect-[640/160] w-full rounded-xl border-0 md:aspect-[1600/300] md:rounded-2xl"
        />
        {!isLoaded && (
          <Skeleton className="absolute inset-0 size-full md:rounded-2xl" />
        )}
      </div>
    </div>
  );
};

export default AdBanner;
